<script>
import topNav from "../../package/topNav.vue";
import footNav from "../../package/footer.vue";
import agentSignInBox from "../../package/agentSignInBox.vue";
import confirmationSection from "../confirmationSection.vue";

export default {
  name: "selectionConfirmLayout",
  data() {
    return {
      showFootTxt: true,
      gray: false,
      privateMode: false,
    };
  },
  created() {
    if (this.$route.path.slice(0,9) === '/private/') {
      this.privateMode = true;
    }
  },
  components: {
    agentSignInBox,
    footNav,
    topNav,
    confirmationSection
  },
  methods: {}
};
</script>

<template>
  <el-container :lg="3" :md="4" :sm="6" :xl="1" :xs="8" class="mainWrapper">
    <el-header style="padding: 0">
      <top-nav v-bind:gray="gray" :privateMode="privateMode"></top-nav>
    </el-header>
    <el-main style="padding: 0; overflow: visible; margin-top: 40px">
      <confirmation-section />
    </el-main>
    <el-footer style="padding: 0">
<!--      <agent-sign-in-box />-->
      <foot-nav :showQus="showFootTxt" :privateMode="privateMode"></foot-nav>
    </el-footer>
  </el-container>
</template>

<style scoped>
.mainWrapper {
  background-color: #ffffff;
  max-width: 1920px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/uConnectReservation/confirm/selectionConfirmLayout.vue